import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_UPDATES_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  RESET_FILTERS,
  FETCH_ROLES_SUCCESS,
  ADD_ROLE_SUCCESS,
  EDIT_ROLE_SUCCESS,
  SET_SELECTED,
  DELETE_ROLE_SUCCESS
} from "./rolesSagas";

export const initialState = {
  currentUser: {},
  isLoading: true,
  filtersDirty: false,
  roles: {},
  primaryButtonDisabled: true,
  selected: {
    organization: null,
    identifier: "",
    name: ""
  }
};

export default handleActions(
  {
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      areChartsLoading: action.payload
    }),

    [RESET_FILTERS]: (state) => {
      return {
        ...state,
        filtersDirty: false,
        primaryButtonDisabled: true,
        selected: {
          ...initialState.selected
        }
      };
    },
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_SELECTED]: (state, action) => ({
      ...state,
      selected: {
        ...state.selected,
        ...action.payload
      }
    }),

    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => {
      return {
        ...state,
        currentUser: action.payload
      };
    },
    [FETCH_ROLES_SUCCESS]: (state, action) => {
      return {
        ...state,
        roles: action.payload
      };
    },
    [ADD_ROLE_SUCCESS]: (state, { payload: { data, orgName } }) => {
      let roles = { ...state.roles, [orgName]: [...state.roles[orgName], data] };

      return {
        ...state,
        roles
      };
    },
    [EDIT_ROLE_SUCCESS]: (state, { payload: { orgName, data } }) => {
      let roles = {
        ...state.roles,
        [orgName]: state.roles[orgName].map((role) => (role.id == data.id ? data : role))
      };

      return {
        ...state,
        roles
      };
    },
    [DELETE_ROLE_SUCCESS]: (state, { payload: { orgName, id } }) => {
      let roles = {
        ...state.roles,
        [orgName]: state.roles[orgName].filter((role) => role.id !== id)
      };

      return {
        ...state,
        roles
      };
    }
  },

  initialState
);
